import { service } from '../../../../helpers/http' 

export const ActionGetGroups = ({ dispatch }, payload) => { 
    return service({
        module: 'domainGroup',
        action: 'getGroups',
        payload: payload
    })
}

export const ActionPostGroups = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroup',
        action: 'postGroups',
        payload: payload
    })
    
}

export const ActionPutGroups = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroup',
        action: 'putGroups',
        payload: payload
    })
    
}

export const ActionDeleteGroups = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroup',
        action: 'deleteGroups',
        payload: payload
    })
    
}
